import { render, staticRenderFns } from "./Cuotas.vue?vue&type=template&id=2624b0d1&"
import script from "./Cuotas.vue?vue&type=script&lang=js&"
export * from "./Cuotas.vue?vue&type=script&lang=js&"
import style0 from "./Cuotas.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports